import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { api } from "../../config/api";
import { toast } from "react-toastify";
import { Lock } from "lucide-react";
import Logo from "../../assets/logo.png";
import video from "../../assets/5262343_Above_Aerial_Area_1920x1080.mp4";

const ResetPasswordComponent = () => {
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [tokenValid, setTokenValid] = useState(true);
    const [error, setError] = useState("");
    const { token } = useParams();
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (password !== confirmPassword) {
            setError("Passwords do not match");
            return;
        }

        if (password.length < 8) {
            setError("Password must be at least 8 characters long");
            return;
        }

        setIsSubmitting(true);
        setError("");

        try {
            const response = await api.post(`/admin-auth/reset-password/${token}`, {
                newPassword: password
            });

            toast.success("Password reset successful. Please login with your new password.");
            navigate("/");
        } catch (error) {
            console.error("Password reset error:", error);
            const errorMessage = error.response?.data?.error || "Password reset failed";
            setError(errorMessage);
            if (error.response?.status === 400 && errorMessage.includes("token")) {
                setTokenValid(false);
            }
        } finally {
            setIsSubmitting(false);
        }
    };

    if (!tokenValid) {
        return (
            <div className="flex min-h-screen justify-center items-center">
                <div className="bg-white p-8 rounded-lg shadow-lg max-w-md w-full text-center">
                    <div className="mb-4 p-4 bg-red-100 text-red-700 rounded">
                        <h3 className="font-bold">Error</h3>
                        <p>The password reset link is invalid or has expired.</p>
                    </div>
                    <button
                        onClick={() => navigate("/")}
                        className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition duration-300"
                    >
                        Back to Login
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div className="flex min-h-screen">
            <div className="lg:w-1/2 hidden lg:block relative">
                <video autoPlay loop muted className="absolute inset-0 w-full h-full object-cover">
                    <source src={video} type="video/mp4" />
                </video>
            </div>

            <div className="lg:w-1/2 w-full bg-white p-8 flex flex-col justify-center items-center">
                <img src={Logo} alt="Logo" className="w-1/5 mb-8" />

                <div className="w-full max-w-md bg-white p-6 rounded-lg shadow-md">
                    <div className="text-center mb-6">
                        <Lock className="w-12 h-12 mx-auto mb-4 text-blue-600" />
                        <h1 className="text-2xl font-bold">Invoice Reset Password</h1>
                        <p className="text-gray-600">Please enter your new password</p>
                    </div>

                    {error && (
                        <div className="mb-4 p-4 bg-red-100 text-red-700 rounded">
                            {error}
                        </div>
                    )}

                    <div className="space-y-4">
                        <div>
                            <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-1">
                                New Password
                            </label>
                            <input
                                type="password"
                                id="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 h-12"
                                placeholder="Enter new password"
                                required
                                minLength={8}
                            />
                        </div>

                        <div>
                            <label htmlFor="confirmPassword" className="block text-sm font-medium text-gray-700 mb-1">
                                Confirm Password
                            </label>
                            <input
                                type="password"
                                id="confirmPassword"
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 h-12"
                                placeholder="Confirm new password"
                                required
                                minLength={8}
                            />
                        </div>

                        <div className="flex items-center gap-4">
                            <div
                                onClick={handleSubmit}
                                className="w-full flex cursor-pointer items-center justify-center space-x-3 py-3 px-6 btnBg rounded-[5px]"
                                disabled={isSubmitting}
                            >
                                {/* <div className="h-[24px] w-[24px] bg-[#fff] rounded-full flex justify-center items-center">
                                    <Lock className="w-5 h-5 text-blue-600" />
                                </div> */}
                                <p className="text-[#fff] text-center flex-1">{isSubmitting ? "Resetting..." : "Reset Password"}</p>
                            </div>
                        </div>
                    </div>

                    <div className="text-center mt-4">
                        <a href="/" className="text-blue-600 hover:text-blue-800">
                            Back to Login
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ResetPasswordComponent;